export default __webpack_public_path__ + "static/media/react-logo.ae626225.svg";